import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';

import { GqlService, TrialSettingKey } from '@shared/services/gql.service';

@Injectable()
export class TrialSettingsService {
  gqlService = inject(GqlService);

  autoHistoricalAdjustmentBoxChecked = 'TRUE';
  plannedVisitMethodology = 'FIRST_VISIT_BASED';

  getAutoHistoricalAdjustmentSetting$() {
    return this.getTrialSettings$().pipe(
      map((data) => {
        return data.find(
          (x) => x.setting_key === TrialSettingKey.TRIAL_SETTING_APPLY_AUTO_HISTORICAL_ADJUSTMENTS
        )?.setting_value;
      })
    );
  }

  getPlannedVisitMethodologySetting$() {
    return this.getTrialSettings$().pipe(
      map((data) => {
        return data.find(
          (x) => x.setting_key === TrialSettingKey.TRIAL_SETTING_PLANNED_VISIT_METHODOLOGY
        )?.setting_value;
      })
    );
  }

  getTrialSettings$() {
    return this.gqlService.listTrialSettings$().pipe(map((response) => response.data || []));
  }
}
